import React, { useState } from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import './styles/buttonNavigationBar.css'; // Import the CSS


const ButtonNavigationBar = ({ activeStep, steps, handleSteps }) => {
  const handleChange = (event, newValue) => {
    handleSteps(newValue);
  };

  return (
    <Paper elevation={3} className="bottom-nav-container">
      <BottomNavigation
        value={activeStep} // <-- use prop, not local state
        onChange={handleChange}
        showLabels
        className="bottom-nav"
      >
        {steps.map((label) => (
          <BottomNavigationAction key={label} label={label} />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

 export default ButtonNavigationBar;